module.exports = __webpack_public_path__ + "static/media/shop.5865acb1.jpeg";